import { openOrderBatch } from "@/features/order-instructions/lib/order-batch-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareOrderInstructionsArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  choiceResult,
  searchedInstead,
  shownResult,
} from "@/features/intelligence/lib/tool-result";

export async function prepareOrderInstructions(
  { seed, ignored, notAnId }: PrepareOrderInstructionsArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openOrderBatch(toolCallId, seed);
  if (seed.clientId === null && seed.clientQuery === null) {
    return shownResult(shown("for the advisor's whole book"), REPLY, ignored);
  }
  const choice = await cardChoice(seed, false);
  if (choice.kind !== "chosen") {
    return choiceResult(
      choice,
      searchedInstead(
        "An order-instruction card is in the chat. Once the client is chosen, it reads that " +
          "client's unsent drafts and signed advices without an order instruction itself, so " +
          "you do not see what it lists. " +
          NOTHING_CREATED,
        seed,
        notAnId,
      ),
      KEEP_OUT,
      ignored,
    );
  }
  return shownResult(
    searchedInstead(shown("for the one client asked for"), seed, notAnId),
    REPLY,
    ignored,
  );
}

function shown(scope: string): string {
  return (
    `An order-instruction card is shown in the chat ${scope}. It reads the unsent drafts and ` +
    "the signed advices without an order instruction itself, so you do not see what it " +
    `lists. ${NOTHING_CREATED}`
  );
}

const NOTHING_CREATED =
  "Nothing has been created or sent: the advisor creates, reviews and sends each one from " +
  "the card";

const KEEP_OUT =
  "do not list or guess its rows, and do not create or send an order instruction yourself";

const REPLY = `points to the card; ${KEEP_OUT}`;
